import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';
import TopNav from '../components/TopNav';
import BottomNav from '../components/BottomNav';

const Rewards = ({ deviceId }) => {
  const [loyalty, setLoyalty] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadLoyalty = useCallback(async () => {
    try {
      const data = await api.getLoyalty(deviceId);
      setLoyalty(data);
    } catch (error) {
      console.error('Error loading loyalty:', error);
    } finally {
      setLoading(false);
    }
  }, [deviceId]);

  useEffect(() => {
    loadLoyalty();
  }, [loadLoyalty]);

  const getTierInfo = (tier) => {
    const tiers = {
      'CADDIE': { next: 'MEMBER', pointsNeeded: 250 },
      'MEMBER': { next: 'PRO', pointsNeeded: 500 },
      'PRO': { next: 'CHAMPION', pointsNeeded: 1000 },
      'CHAMPION': { next: 'MAX', pointsNeeded: 0 }
    };
    return tiers[tier] || tiers['CADDIE'];
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#FEFEE3', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <TopNav deviceId={deviceId} />
        <p style={{ color: '#4C956C' }}>LOADING...</p>
        <BottomNav currentPath="/rewards" />
      </div>
    );
  }

  const tierInfo = getTierInfo(loyalty.tier);
  const progress = loyalty.tier === 'CHAMPION' ? 100 : Math.min(100, (loyalty.total_spent / tierInfo.pointsNeeded) * 100);

  return (
    <div style={{ minHeight: '100vh', background: '#FEFEE3', paddingBottom: '100px' }}>
      <TopNav deviceId={deviceId} currentPath="/rewards" />
      
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <h1 style={{ fontSize: '24px', color: '#2C6E49', marginBottom: '30px', textAlign: 'center' }}>[ REWARDS PROGRAM ]</h1>
        
        <div className="retro-card" style={{ background: '#2C6E49', color: '#FEFEE3', padding: '40px', marginBottom: '30px', textAlign: 'center' }}>
          <p style={{ fontSize: '12px', marginBottom: '10px' }}>YOUR POINTS</p>
          <p style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '10px' }}>{loyalty.total_points}</p>
          <p style={{ fontSize: '14px', color: '#FFC857' }}>TIER: {loyalty.tier}</p>
        </div>
        
        <div className="retro-card" style={{ background: '#FFF', padding: '30px', marginBottom: '30px' }}>
          <h3 style={{ fontSize: '16px', color: '#2C6E49', marginBottom: '20px' }}>PROGRESS TO {tierInfo.next}</h3>
          <div style={{ background: '#F7F6D8', border: '2px solid #000', height: '30px', position: 'relative', marginBottom: '10px' }}>
            <div style={{ background: '#4AE54A', height: '100%', width: `${progress}%`, transition: 'width 0.5s' }} />
          </div>
          <p style={{ fontSize: '12px', color: '#4C956C', textAlign: 'center' }}>{Math.round(progress)}% TO NEXT TIER</p>
        </div>
        
        <div className="retro-card" style={{ background: '#FFF', padding: '30px', marginBottom: '30px' }}>
          <h3 style={{ fontSize: '16px', color: '#2C6E49', marginBottom: '20px' }}>YOUR STATS</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px' }}>
            <div>
              <p style={{ fontSize: '10px', color: '#4C956C', marginBottom: '5px' }}>ORDERS</p>
              <p style={{ fontSize: '24px', fontWeight: 'bold' }}>{loyalty.num_orders}</p>
            </div>
            <div>
              <p style={{ fontSize: '10px', color: '#4C956C', marginBottom: '5px' }}>SPENT</p>
              <p style={{ fontSize: '24px', fontWeight: 'bold' }}>${loyalty.total_spent.toFixed(2)}</p>
            </div>
            <div>
              <p style={{ fontSize: '10px', color: '#4C956C', marginBottom: '5px' }}>POINTS</p>
              <p style={{ fontSize: '24px', fontWeight: 'bold' }}>{loyalty.total_points}</p>
            </div>
          </div>
        </div>
        
        <div className="retro-card" style={{ background: '#FFF', padding: '30px' }}>
          <h3 style={{ fontSize: '16px', color: '#2C6E49', marginBottom: '20px' }}>HOW IT WORKS</h3>
          <ul style={{ fontSize: '12px', color: '#4B4B4B', lineHeight: '2' }}>
            <li>Earn 1 point per $1 spent</li>
            <li>Caddie (0-$250): Welcome tier</li>
            <li>Member ($250-$500): 5% off all orders</li>
            <li>Pro ($500-$1000): 10% off + early access</li>
            <li>Champion ($1000+): 15% off + VIP perks</li>
          </ul>
        </div>
      </div>
      
      <BottomNav currentPath="/rewards" />
    </div>
  );
};

export default Rewards;
